

import {  
  loadRoleDataInProgress,
  loadRoleDataSuccess,
  loadRoleDataFailure,
  closeRoleDialog,
  roleOperationCompleted,
} from "../state/role/actions";
import swal from 'sweetalert';
import configData from "../config.json";
import { errorSweetAlert, oopsSweetAlert } from '../components/SweetAlertMessages';
import { oktaAuth } from '../auth/okta';
const serverBasePath=configData.SERVER_API_URL;


export const loadRoleList = (page=0,pageSize=10) => async (dispatch) => {
  
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadRoleDataInProgress());
    const response = await fetch(serverBasePath+"/role/getAllRoles?page="+page+"&pageSize="+pageSize,
    {
      method: "GET", 
      headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
      }
    });
    const result = await response.json();
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    dispatch(loadRoleDataSuccess(result));
  } catch (e) {
    dispatch(loadRoleDataFailure());
    errorSweetAlert(e); 
  }
};

export const addNewRole = (data) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  dispatch(loadRoleDataInProgress());
  try {
      const response = await fetch(serverBasePath+"/role/addNewRole", 
      {
          method: "POST",  
          headers: {
            Authorization: 'Bearer ' + token,       
            'Content-Type': 'application/json',
          },
          body:JSON.stringify(data)
      });
      dispatch(roleOperationCompleted());
      const result = await response.json();
      if(response.status !== 200){
          oopsSweetAlert(result);
          return;
      }
      dispatch(closeRoleDialog());
      swal({
          title: "Success",
          text: result.message,
          icon: "success",
          closeOnClickOutside:false,
          closeOnEsc: false,
          allowOutsideClick: false,
      }).then(marked => {
        if (marked) {
          dispatch(loadRoleList(''));
        }
      });
  } catch (e) {
      dispatch(loadRoleDataFailure());
      errorSweetAlert(e);
  }
};


export const deleteRole = (roleId) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken();
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadRoleDataInProgress());
          const response = await fetch(configData.SERVER_API_URL+"/user/role/delete/"+roleId,
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            }
          });
          dispatch(roleOperationCompleted()); 
          const result = await response.json();
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                dispatch(loadRoleList(''));
              }
          });
      } catch (e) {   
          dispatch(loadRoleDataFailure());
          errorSweetAlert(e); 
      }
  };
};